import dam_helper from '@packs/pages/diagrams/tiete_river/helpers/dam_helper'
import store from '../../../../store/store'
import ValueBox from '../value_box/value_box'
import('./dam.css')

export default function Dam(opts={}){
    BaseConstructor.call(this)
    let elements = {}
    let context = this
    let {container, path, options, id} = opts
    let valueBox

    this.generate = () =>{
        elements.container = this.createElement('div', 'dam-container', '')

        $(document.body).append(elements.container)

        setFloodgates()

        updatePosition()        

        eventsHandler()
    }

    this.getElement = () =>{
        return elements.container
    }

    const eventsHandler = _ =>{
        store.damStore.subscribe('SET_DAMS', dams=>{
            setFloodgates()
        })
        store.damStore.subscribe('SET_DAM_EVENT', dam_id=>{
            if(dam_id === id){
                setFloodgates()
            }  
        })
        $(elements.container).on('click', _ =>{
            store.informationCardStore.setBlockStatus(true)
            store.informationCardStore.setObjType('dam')
            store.informationCardStore.setStationId(id)
            store.informationCardStore.updateCardPosition(elements.container)
        })
        $(elements.container).on('mouseleave', _ =>{
            if(!store.informationCardStore.getBlockStatus()){
                store.informationCardStore.setStationId(undefined)
            }
        })

        store.diagramStore.subscribe('PATH_UPDATE_POSITION', _path=>{
            if(_path === path){
                updatePosition()    
            }
        })
    }

    const setFloodgates = _=>{
        let floodgates = dam_helper.getDamGates(id)
        if(!floodgates){
            let dam = store.damStore.getDam(id)
            floodgates = dam && dam.params ? dam.params.gates : undefined
        }            
        
        let el_gates_container = this.createElement('div', 'floodgates-container', '')
        
        $.each(floodgates, (gate_id, gate)=>{
            let status = gate.status === 'true' || gate.status === true 
            $(el_gates_container).append(this.createElement('div', `floodgate ${status ? "open" : ''}`, ''))
        })

        $(elements.container).html(el_gates_container)
        
    }
    
    function updatePosition(){
        if(path){
            let offset = $(path).offset()
            let bbox = path.getBBox()

            let horizontal = (bbox.width) ? true : false
            
            $(elements.container).css({
                top: horizontal ? offset.top - (elements.container.clientHeight / 2) : offset.top + convertPosition(options.position.value, 'h'),
                left: horizontal ? offset.left - elements.container.clientWidth / 2 + convertPosition(options.position.value, 'w') : offset.left - (elements.container.clientWidth / 2),
                'transform': horizontal ? 'rotate(90deg) translateY(0%)' : 'translateY(-50%)'
            })

        } else {

            let position = opts.options.position

            $(elements.container).css({
                top: convertPositionByCanvas(position[1], 'h'),
                left: convertPositionByCanvas(position[0], 'w')
            })
        }
        
    }

    const convertPosition = (pos, type) =>{
        let box = path.getBBox() //status do path
        return pos * (box.height || box.width) / 100 //convertendo porcentagem em pixel
    }

    const convertPositionByCanvas = (pos, type) =>{
        let container_w = $(container).width()
        let container_h = $(container).height()
        if(type == 'w'){
            return pos * container_w / 100
        } else {
            return pos * container_h / 100
        }
    }
}

Dam.prototype = Object.create(BaseConstructor.prototype)